export default "__VITE_ASSET__4e214f5a__"